import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { RegistrationProduct } from '@appShared/services/registrations.service'
import { GUID_, guids } from '@appShared/guids'

const baseUri = window.location.origin /* https://southwestern-learning-web-portal-test-as.azurewebsites.net */

export const environment = {
   production: false,
   apiConfig: {
      authorityDomain: 'testsecure.collegeentranceadvantage.com',
      endpointUri: `${baseUri}/api`,
      msalConfig: {
         auth: {
            /* guids below used to obfuscate the clientId in PROD */
            [guids.get(GUID_.B8C119E38553467B8ED361CB1AC821C5)]: 'aad9bc76-a4ed-49ba-a5a5-7202e8007c56'
         }
      },
      piiLoggingEnabled: true,
      scopes: [
         'https://swfcb2c.onmicrosoft.com/swfc-learning-portal-web-api/dev.subscription.manage',
         'https://swfcb2c.onmicrosoft.com/swfc-learning-portal-web-api/dev.content.subscribed'
      ],
      userFlows: {
         defaultSignUpSignIn: 'B2C_1_CEA_SUSI_v1_test'
      }
   },
   appStore: {
      apple: 'https://apps.apple.com/us/app/southwestern-lead/id6478800540 ',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.southwestern.lead'
   },
   baseUri,
   brightcove: {
      accountId: 753829919001,
      experiences: {
         dashboard: '65e8c10567acf13ae75b3dfd',
         faq: '661436a3fd8b4685703d56bf',
         meetTheMentorsUrl: 'https://site-28869320.bcvp0rtal.com/',
         personalitiesPortalUrl: 'https://site-76420120.bcvp0rtal.com'
      },
      playerId: 'KrH874wOd'
   },
   contactUsUri: 'https://southwesternadvantage.com/about/',
   dealerApiUri: 'https://testportal.advantage4dealers.com/api/dealer',
   playerUri: 'player',
   publicCdn: {
      uri: 'https://swfclearningprod.blob.core.windows.net/cea',
      moduleCourseImagesFolder: 'course-images'
   },
   resourceMenuUris: {
      academicResources: 'https://www.advantage4teens.com',
      contest: 'https://sites.google.com/view/southwesternlead',
      privacyPolicy: 'https://southwesternadvantage.com/privacy-policy/'
   },
   routes: SITE_DIRECTORY_ROUTES, //TODO: ???
   tprSSOEndpoint: 'https://secure.princetonreview.com/ltisso/launch',
   userPrincipalIdHeaderName: 'UserPrincipalId-29239E59E0924FC4',
   /* guids below used to obfuscate in PROD */
   [GUID_.E567D0E4603F4A7580212E770DE079AA]: '1204683634232208',                 //serviceLayerClientId
   [GUID_.D9A8BADB30FA4EDE975EAE987AABFBD4]: 'e91ee2fd0f634a28aa43e0223c3864bf', //serviceLayerClientSecret
   registrationProducts: [
      {
         productSourceId: '' /* ALL Sites */,
         showLandingIfSingle: false,
         registrationSites: [
            {
               uri: 'https://localhost:62246/registration',
               uriSuffix: '?token=',
               appendToken: true,
               appendSubscriptionId: true,
               logoUri:
                  'https://swfclearningprod.blob.core.windows.net/cea/course-images/CED.png?v=240611',
               logoAlt: 'College Entrance Advantage Digital',
               description:
                  'College Entrance Advantage Digital - The Program that helps you conquer the SAT and ACT.'
            },
            {
               uri: 'https://localhost:62246/registration',
               uriSuffix: '?token=',
               appendToken: true,
               appendSubscriptionId: true,
               logoUri:
                  'https://swfclearningprod.blob.core.windows.net/cea/course-images/APD.png?v=240611',
               logoAlt: 'Advanced Placement Digital',
               description:
                  'Advanced Placement Digital - Everything you need for top AP scores.'
            }
         ]
      } as RegistrationProduct,
      {
         productSourceId: 'CED' /* College Entrance Advantage Digital */,
         showLandingIfSingle: false,
         registrationSites: [
            {
               uri: 'https://localhost:62246/registration',
               uriSuffix: '?token=',
               appendToken: true,
               appendSubscriptionId: true,
               logoUri:
                  'https://swfclearningprod.blob.core.windows.net/cea/course-images/CED.png?v=240611',
               logoAlt: 'College Entrance Advantage Digital',
               description:
                  'College Entrance Advantage Digital - The Program that helps you conquer the SAT and ACT.'
            }
         ]
      } as RegistrationProduct,
      {
         productSourceId: 'APD' /* Advanced Placement Digital */,
         showLandingIfSingle: false,
         registrationSites: [
            {
               uri: 'https://localhost:62246/registration',
               uriSuffix: '?token=',
               appendToken: true,
               appendSubscriptionId: true,
               logoUri:
                  'https://swfclearningprod.blob.core.windows.net/cea/course-images/APD.png?v=240611',
               logoAlt: 'Advanced Placement Digital',
               description:
                  'Advanced Placement Digital - Everything you need for top AP scores.'
            }
         ]
      } as RegistrationProduct
   ] as RegistrationProduct[]
};
